module["exports"] = [
  "####-#####",
  "####-######"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/phone_number/formats.js
// module id = 1379
// module chunks = 0